import { SearchCampaignItem } from 'modules/campaigns/types/SearchCampaigns';
import { Campaign } from 'services/campaign/types';

export const hasCampaignInReview = ({
  campaigns
}: {
  campaigns: (Campaign | SearchCampaignItem)[];
}): boolean => {
  return campaigns.some((campaign) => !!campaign?.needsReview);
};
